import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=970b0ae2"
import script from "./OrderModal.vue?vue&type=script&lang=js"
export * from "./OrderModal.vue?vue&type=script&lang=js"
import style0 from "./OrderModal.vue?vue&type=style&index=0&id=970b0ae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports